module.exports = __webpack_public_path__ + "img/ep2-2.7da356fd.png";